<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.707 2.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 0-1.414l-7-7ZM11 6a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V6Zm0 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
    </svg>
</template>
